module.exports = __webpack_public_path__ + "static/media/burger_black.d7c0eb80.svg";